import { FormGroup } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
const ROOT_URL = environment.ApiRoot + '/congthucdinhmuc';
const ROOT_URL_EXPORT = environment.ApiRoot + '/export-bom';

@Injectable()
export class BOMService {
	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }

	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(ROOT_URL + '/BOM_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	GetListThanhPham(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(ROOT_URL+`/GetListThanhPham`, { headers: httpHeaders});
	}

	GetSoGiaiDoan(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(ROOT_URL+`/GetSoGiaiDoan`, { headers: httpHeaders});
	}

	GetListQTSX(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(ROOT_URL+`/GetListQTSX`, { headers: httpHeaders});
	}

	insert(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(ROOT_URL+'/BOM_INSERT_NEW', item, { headers: httpHeaders });
	}

	edit(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(ROOT_URL+'/BOM_UPDATE_NEW', item, { headers: httpHeaders });
	}

	delete(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("Id", item.toString());
		return this.http.get<any>(ROOT_URL+`/BOM_Delete`, { headers: httpHeaders, params: params });
	}

	cancel(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("Id", item.toString());
		return this.http.get<any>(ROOT_URL+`/BOM_Cancel`, { headers: httpHeaders, params: params });
	}

	accept(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(ROOT_URL+'/BOM_XEMXET_NEW', item, { headers: httpHeaders });
	}

	confirm(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(ROOT_URL+'/BOM_CONFIRM_NEW', item, { headers: httpHeaders });
	}

	gdkconfirm(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(ROOT_URL+'/BOM_GDK_CONFIRM_NEW', item, { headers: httpHeaders });
	}

	getBOMBTP(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(ROOT_URL+'/LIST_NPL_WITH_PARAMS_BTP', item, { headers: httpHeaders });
	}

	detail(Id: number, replication: boolean = false): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams()
		.set("Id", Id.toString())
		.set("replication", replication.toString());
		return this.http.get<any>(ROOT_URL+`/BOM_DETAIL_NEW`, { headers: httpHeaders, params: params });
	}

	transfer(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("Id", item.toString());
		return this.http.get<any>(ROOT_URL+`/TRANSFER`, { headers: httpHeaders, params: params });
	}
	importBOM(data: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(ROOT_URL+'/import_bom', data, { headers: httpHeaders });
	}
	viewDetail(_id: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("_id", _id.toString());
		return this.http.get<any>(ROOT_URL+`/view_detail`, { headers: httpHeaders, params: params });
	}
	exportBOM(_id: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("id", _id.toString());
		return this.http.get<Blob>(ROOT_URL_EXPORT + '/Export', {
			headers: httpHeaders,
			params: params,
			responseType: 'blob' as 'json'
		});
	}
	viewTree(_id: number, _rep: number = 0): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("_id", _id.toString()).set("_replica", _rep.toString());;
		return this.http.get<any>(ROOT_URL+`/view_tree`, { headers: httpHeaders, params: params });
	}
	template(kindOf: number = 0): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("kindOf", kindOf.toString());
		return this.http.get<Blob>(ROOT_URL + '/template', {
			headers: httpHeaders,
			params: params,
			responseType: 'blob' as 'json'
		});
	}
}
